import type { Experience } from '../experience'
import { bundleForExperience, fetchUnifiedManifest } from './unifiedManifest'

function injectStyles(hrefs: string[]): void {
  for (const href of hrefs) {
    if (document.querySelector(`link[data-unified-css="${href}"]`)) continue
    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.href = href
    link.dataset.unifiedCss = href
    document.head.appendChild(link)
  }
}

export async function loadExperienceApp(experience: Experience): Promise<void> {
  const manifest = await fetchUnifiedManifest()
  const bundle = bundleForExperience(manifest, experience)
  injectStyles(bundle.css)
  await import(/* @vite-ignore */ bundle.entry)
}
